module.exports = __webpack_public_path__ + "img/imprimax_logo.9af4bbc9.png";